import React, { useState } from 'react'
import "./settings_styles/settingspage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from 'react-redux';
import { theme_color_change } from '../../reduxContainer/StateActions';
import { usersRef } from '../../firebase';
import LoadingPage from '../LoadingPage';
import swal2 from 'sweetalert2';

const handleSaveThemeColor = (email_id, theme_color, dispatch) => {
    const currentUserDocRef = usersRef.doc(email_id);
    currentUserDocRef.update({
        theme_color: theme_color,
    }).then(() => {
        dispatch(theme_color_change(theme_color));
        swal2.fire({
            icon: 'success',
            title: `Theme Color Changed!`,
            showConfirmButton: false,
            timer: 1500
        })
    });
}

const SettingsPage = () => {
    const colorCheck = useSelector((state) => state.themeColor);
    const [colorState, setColorState] = useState(colorCheck);
    const usersData = useSelector((state) => state.userData);
    const dispatch = useDispatch();

    return (
        <>
            {
                usersData.email ?
                    <div className='settingspage_container'>
                        <div className='theme_container'>
                            <span>Theme Color</span>
                            <div className='color_box_container'>
                                <div className='color_box' style={{ backgroundColor: "#00a389" }} onClick={() => setColorState("#00a389")}>
                                    {colorState === "#00a389" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#2073C0" }} onClick={() => setColorState("#2073C0")}>
                                    {colorState === "#2073C0" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#a300a3" }} onClick={() => setColorState("#a300a3")}>
                                    {colorState === "#a300a3" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#a30036" }} onClick={() => setColorState("#a30036")}>
                                    {colorState === "#a30036" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#e64b00" }} onClick={() => setColorState("#e64b00")}>
                                    {colorState === "#e64b00" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#26a300" }} onClick={() => setColorState("#26a300")}>
                                    {colorState === "#26a300" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>

                                <div className='color_box' style={{ backgroundColor: "#000000" }} onClick={() => setColorState("#000000")}>
                                    {colorState === "#000000" ? <FontAwesomeIcon icon={faCheck} className='check_icon' /> : <></>}
                                </div>
                            </div>
                            <button className='save_changes_btn' onClick={() => handleSaveThemeColor(usersData.email, colorState, dispatch)}>Save Theme</button>
                        </div>
                    </div>
                    :
                    <LoadingPage />
            }

        </>
    )
}

export default SettingsPage